import script from "./CustomTableCellTiptap.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTableCellTiptap.vue?vue&type=script&setup=true&lang=js"

import "./CustomTableCellTiptap.vue?vue&type=style&index=0&id=fe0e3202&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe0e3202"]])

export default __exports__